export { default } from './WidgetLayout';



// WEBPACK FOOTER //
// ./app/components/layouts/WidgetLayout/index.js